import React from 'react';
interface BotanicalGProps {
  className?: string;
  color?: string;
}
export function BotanicalG({
  className = 'w-24 h-24',
  color = '#D4AF37'
}: BotanicalGProps) {
  return;
}